
import { env } from '@env';
import { httpUtil } from '@/framework';
import { GetCustomerOverviewResponse } from './Types';
import { GetCustomerReportRequest } from '../Types';

export const getCustomerNewOverview = httpUtil.createHttpRequestMeta<
    GetCustomerReportRequest,
    GetCustomerOverviewResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/new-overview',
    method: 'GET',
    authentication: 'bearer'
});
